import Typography from '@mui/material/Typography';
import { GradientTypography } from '../../gradients/GradientTypography';

type ParticipantFillProps = {
  currentFill: number;
  maxFill: number;
};

export default function ParticipantFill({
  currentFill,
  maxFill,
}: ParticipantFillProps) {
  return (
    <Typography variant="h5">
      <GradientTypography
        variant="h5"
        gradientColor="primary.vertical"
        sx={{
          textTransform: 'uppercase',
          pr: 2,
          pb: 4,
          display: 'inline-block',
        }}
      >
        Participants
      </GradientTypography>
      {currentFill > maxFill ? maxFill : currentFill}/{maxFill}
    </Typography>
  );
}
